import { useSelector } from 'react-redux';
import { useDrfqOrderbook } from '@paradigm/features/src/unified-rfqs/contexts/drfqs';
import { useDrfqRfq } from '@paradigm/features/src/unified-rfqs/ui/rfq-context';
import { getUserTicker } from '@paradigm/store/auth';
import { useRfqExpansionState } from '../rfqs/rfq-expansion-context';
import { useContextMenuActions } from '../context-menu/context-menu';
import { renderSecondaryRows, ScreenPrices } from './Orderbook';
import PrimaryOrdersRow from './PrimaryOrdersRow';

export default function OrderbookDrfqRow() {
  const rfq = useDrfqRfq();
  const isExpanded = useRfqExpansionState(rfq.id);
  const contextMenu = useContextMenuActions();
  const [bids, asks] = useDrfqOrderbook(rfq.id);

  const userDesk = useSelector(getUserTicker)!;

  const filteredBids = bids.filter(
    (bid) => bid.desk !== userDesk && bid.type !== 'HIDDEN',
  );
  const filteredAsks = asks.filter(
    (ask) => ask.desk !== userDesk && ask.type !== 'HIDDEN',
  );
  const [firstBid, ...remainingBids] = filteredBids;
  const [firstAsk, ...remainingAsks] = filteredAsks;

  const secondaryRows =
    isExpanded &&
    renderSecondaryRows({
      bids: remainingBids,
      asks: remainingAsks,
      onPriceClick: contextMenu.openDetailsModal,
      rfqId: rfq.id,
    });

  const screenRow = isExpanded && <ScreenPrices />;

  return (
    <div aria-label="quotes">
      <PrimaryOrdersRow
        isMarketRow
        ask={firstAsk}
        bid={firstBid}
        isExpanded={isExpanded}
        onPriceClick={contextMenu.openDetailsModal}
      />
      {secondaryRows}
      {screenRow}
    </div>
  );
}
